// extracted by mini-css-extract-plugin
export default {"social-links":"SocialLinks_social-links__gRFhf","slide-in-right":"SocialLinks_slide-in-right__bMbbS","icon":"SocialLinks_icon__qdzk8"};